// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { useTranslation } from "react-i18next";
import type { TaskKind } from "@/api/hooks/use-tasks";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

/**
 * Which side of the fence a task type sits on.
 *
 * Both kinds are tinted rather than one being an outline: the distinction decides whether the type
 * is editable here at all, so neither should read as the unremarkable default.
 */
const KIND_CLASS: Record<TaskKind, string> = {
  custom: "bg-[#E6F4EA] border-green-200 text-foreground dark:bg-green-950 dark:text-green-300 dark:border-green-900",
  builtIn: "bg-[#E3F1FF] border-blue-200 text-foreground dark:bg-blue-950 dark:text-blue-300 dark:border-blue-900",
};

export function TaskKindBadge({ kind, className }: { kind: TaskKind; className?: string }) {
  const { t } = useTranslation("back-office");
  return (
    <Badge variant="secondary" className={cn("font-normal", KIND_CLASS[kind], className)}>
      {t(`tasks.kind.${kind}`)}
    </Badge>
  );
}
